<app-layout *ngIf="shouldShowLayout()"></app-layout>
<router-outlet *ngIf="!shouldShowLayout()"></router-outlet>
